import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand, faCompress } from '@fortawesome/free-solid-svg-icons';
import {useFilterContext, useFilterDispatch} from '../contexts/FilterContextProvider';
import {updateHistory} from '../utils/data';

function Fullscreen() {
    const filters = useFilterContext();
    const filterDispatch = useFilterDispatch();
    const history = useHistory();
    let newFilters = JSON.parse(JSON.stringify(filters));

    const escapeFullscreen = e => {
        if (e.keyCode === 27 && !filters.map.includes("full")) {
            document.removeEventListener("keydown", escapeFullscreen, false);
            newFilters.map.splice(newFilters.map.indexOf("map"), 1);
            filterDispatch({
                type: 'fullscreen',
                payload: 'full'
            });
            updateHistory(history, newFilters);
        }
    };
    
    const toggleFullscreen = (e) => {
        if (!filters.map.includes("full")) {
            document.addEventListener("keydown", escapeFullscreen, false);
            newFilters.map.push("full");
        }
        else {
            document.removeEventListener("keydown", escapeFullscreen, false);
            newFilters.map.splice(newFilters.map.indexOf("map"), 1);
        }
        
        filterDispatch({
            type: 'fullscreen',
            payload: 'full'
        });
        updateHistory(history, newFilters);
    };

    return(
        <div id="fullscreen" className="esri-widget--button" onClick={(e) => toggleFullscreen(e)}>
            <div className="esri-icon">
                <FontAwesomeIcon icon={filters.map.includes("full") ? faCompress : faExpand} aria-label={filters.map.includes("full") ? "Exit fullscreen" : "Enter fullscreen"} />
            </div>
        </div>
    );
}

export default memo(Fullscreen);